<template>
  <div class="tm-container ">
    <div>
      <div class="nav-btn center">
        <img class="re-logo" @click="home_route()" :src="require('@/assets/Desktop/Home_Landing/RE-Logo-Light.png')" alt="">
        <h1 class="tm-title">Our Team</h1>
      </div>
    </div>
    <div class="flex space-evenly vertical-center">
      <div class="tm-content-container">
          <img class="page-num" :src="require('../../assets/Mobile/Mobile_Landing/04-img.svg')" alt="Page 4">
          <div class="flex column spacing no-bottom">
            <h3 class="tm-subtitle">Donovan Johnson - CEO</h3>
            <p class="tm-text">Donovan Johnson is the founder and owner of Royal Experience. In 2000, he earned a BS in business Marketing from Oakwood University. This degree was quickly put to good use in 2001 when he created an internet radio station (Church Beat Radio) which eventually became the largest online radio station of its genre (urban gospel) on the internet.  Throughout his 15+ years doing internet radio, Donovan expanded his business from 1 station to 122 while covering an assortment of genres and reaching millions of listeners. During this period of time he also produced hundreds of successful radio advertising campaigns, hired talented and eventual award winning radio personalities, funded /promoted several concerts; and produced many popular radio shows. It was the aforementioned concerts in which the thought of Royal Experience began.  Through successfully fulfilling artists’ riders and last minute special requests, Donovan, thought that there had to be an easier and more efficient way to satisfy the customer’s needs and in 2014, the software based concierge idea was born. </p>
          </div>
          <div class="flex column spacing">
            <div>
              <h3 class="tm-subtitle">Ronald Loveall - Operations Director</h3>
              <p class="tm-text">Ronald Loveall has over 10years experience in security; body guarding for professional athletes, celebrities and heads of corporations. He also has years of experience running Vip services for exclusive businesses and members only clubs. Ronald’s specialty is organizing events in a way that gives the client a great and confidential experience and assures their transportation and safety throughout the event.</p>
            </div>
            <div>
              <h3 class="tm-subtitle">Andrew Tsao — IT Director</h3>
              <p class="tm-text">Andrew Tsao is a full stack developer with a passion for creating thoughtful user interfaces, reducing friction, and working with others. He graduated from Arizona State University with his bachelors in Computer Science and has been an active member of the startup world ever since. He loves interesting challenges, new opportunities, and, in his free time, cheering for the Seattle Seahawks.</p>
            </div>
            <div>
              <h3 class="tm-subtitle">Jeff Otto - Graphics Design Manager </h3>
              <p class="tm-text">Jeff Otto studied Business Communication at Arizona State University and Graphic Design at the Art Institute of Phoenix. His career in the creative industry started with a Jr. Graphic Designer position to becoming a Creative Director and Creative Development Specialist. His passion in finding creative, unique, and impactful ideas has made him a leader in building brands.</p>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        data () {
            return {
            }
        },
        methods: {
            home_route: function(e) {
                this.$router.push({'name': 'Home'})
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 880px) {
        .tm-container {
            background-image: url(../../assets/Mobile/Mobile_Landing/our_team_bg.jpg) !important;
            background-position: center !important; /* Center the image */
            background-repeat: no-repeat !important; /* Do not repeat the image */
            background-size: 100% 100% !important;
        }

        .tm-text, .tm-title {
            text-align: center !important;
            margin: 35px 0 !important;
        }

        .tm-content-container {
            display: flex !important;
            justify-content: center!important;
            flex-direction: column !important;
        }

        .page-num {
            display: block !important;
            margin: 10px 0 !important;
        }

        .mobile-team {
            display: block !important;
            width: auto !important;
            height: 415px !important;
        }

        .tm-subtitle {
          text-align: center;
        }

        .no-bottom {
          margin-bottom: 0 !important;
        }
    }

    .page-num, .mobile-team {
        display: none;
    }

    .tm-content-container {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between
    }

    .tm-container {
        background-image: url(../../assets/Desktop/Home_Landing/Our_Team_BG_IMG.jpg);
        overflow: hidden;
    }

    .tm-title {
        color: #FFFFFF;	font-family: Trirong;	
        font-size: 32px;	
        font-weight: 800;	
        line-height: 44px;
        margin: 35px 0 0 0;
    }

    .tm-text {
        color: #FFFFFF;	font-family: Trirong;	
        font-size: 15px;	
        letter-spacing: 1px;	
        line-height: 28px;
        width: 500px;
        font-weight: 400;
    }

    .tm-subtitle {
        color: #FFFFFF;	font-family: Trirong;	
        font-weight: 700;
        margin: 0;
    }

    .nav-btn {
      margin: 25px 0px;
    }

    .spacing { 
      margin: 25px;
    }
</style>



// WEBPACK FOOTER //
// src/components/our_team/Team.vue